export type StatePath = string;

export enum StateScope {
  Global = 'Global',
  Carried = 'Carried',
}
